(function () {
  var TAB_LINKS = {
    all: '/collections/all-cases',
    coll: '/collections',
    acc: '/collections/accessories'
  };

  function start(root) {
    if (root.__cf) return;
    root.__cf = true;

    var shop = root.querySelector('[data-cf-shop]');
    var panel = root.querySelector('[data-cf-panel]');
    if (!shop || !panel) return;
    var trigger = shop.querySelector('.cf-top__link');
    var closeTimer = null;

    function open() { window.clearTimeout(closeTimer); closeFind(); root.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { root.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    function later() { window.clearTimeout(closeTimer); closeTimer = window.setTimeout(close, 180); }

    shop.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') open(); });
    shop.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') later(); });
    panel.addEventListener('pointerenter', function () { window.clearTimeout(closeTimer); });
    panel.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') later(); });
    shop.addEventListener('focusin', open);

    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !root.classList.contains('is-open')) {
        e.preventDefault();
        open();
      }
    });

    /* ------------------------- search dropdown -------------------------
       Same panel behaviour as Shop. Results come from the theme's JSON
       search view, which is Shopify's own index, so a search for flowers
       finds the floral cases through their keyword tags, not just titles. */

    var find = root.querySelector('[data-cf-search]');
    var findPanel = root.querySelector('[data-cf-search-panel]');
    var input = root.querySelector('[data-cf-search-input]');
    var results = root.querySelector('[data-cf-search-results]');
    var msg = root.querySelector('[data-cf-search-msg]');
    var allLink = root.querySelector('[data-cf-search-all]');
    var chips = root.querySelector('[data-cf-search-chips]');
    var clearBtn = root.querySelector('[data-cf-search-clear]');
    var findTrigger = root.querySelector('[data-cf-search-trigger]');
    var typeTimer = null;
    var hoverTimer = null;
    var cache = {};
    var seq = 0;

    /* Closing only hides the panel. The query and the results it found are
       left in place, so hovering back on picks up exactly where you were.
       The X is what actually empties it. */
    function closeFind() {
      if (!find) return;
      window.clearTimeout(hoverTimer);
      root.classList.remove('is-finding');
      findTrigger.setAttribute('aria-expanded', 'false');
    }

    function openFind() {
      if (!find) return;
      window.clearTimeout(hoverTimer);
      window.clearTimeout(closeTimer);
      close();
      root.classList.add('is-finding');
      findTrigger.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { input.focus(); }, 60);
    }

    /* Leaving the trigger starts a short countdown; moving onto the panel
       cancels it. Same as Shop. */
    function findLater() {
      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(closeFind, 180);
    }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function card(it) {
      return '<a class="cf-card" href="' + esc(it.u) + '">' +
        '<span class="cf-card__img"><img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" width="500" height="625" loading="lazy"></span>' +
        '<span class="cf-card__name">' + esc(it.t) + '</span>' +
      '</a>';
    }

    function idle() {
      results.hidden = true;
      results.innerHTML = '';
      msg.hidden = true;
      allLink.hidden = true;
      if (chips) chips.hidden = false;
      clearBtn.hidden = true;
    }

    function paint(q, data) {
      var items = (data.items || []).slice(0, 5);
      var total = data.count || 0;

      if (chips) chips.hidden = true;

      if (!items.length) {
        results.hidden = true;
        results.innerHTML = '';
        allLink.hidden = true;
        msg.hidden = false;
        msg.textContent = 'Nothing matches that';
        return;
      }

      results.innerHTML = items.map(card).join('');
      results.hidden = false;
      msg.hidden = true;

      if (total > items.length) {
        allLink.hidden = false;
        allLink.textContent = 'See all ' + total + ' results';
        allLink.href = '/search?q=' + encodeURIComponent(q);
      } else {
        allLink.hidden = true;
      }
    }

    function run() {
      var q = (input.value || '').trim();
      clearBtn.hidden = q === '';

      if (q.length < 2) { idle(); return; }

      if (cache[q]) { paint(q, cache[q]); return; }

      var mine = ++seq;
      if (chips) chips.hidden = true;
      msg.hidden = false;
      msg.textContent = 'Searching';

      fetch('/search?q=' + encodeURIComponent(q) + '&type=product&view=cfjson', {
        headers: { 'X-Requested-With': 'fetch' }
      })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          if (mine !== seq) return;
          var data;
          try { data = JSON.parse(txt); } catch (e) { msg.textContent = 'Search is having a moment'; return; }
          cache[q] = data;
          paint(q, data);
        })
        .catch(function () {
          if (mine === seq) { msg.hidden = false; msg.textContent = 'Search is having a moment'; }
        });
    }

    if (find && findPanel && input) {
      findTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (root.classList.contains('is-finding')) closeFind();
        else openFind();
      });

      find.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') openFind(); });
      find.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') findLater(); });
      findPanel.addEventListener('pointerenter', function () { window.clearTimeout(hoverTimer); });
      findPanel.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') findLater(); });

      input.addEventListener('input', function () {
        window.clearTimeout(typeTimer);
        typeTimer = window.setTimeout(run, 140);
      });

      /* The X wipes the search and shuts the panel. */
      clearBtn.addEventListener('click', function () {
        input.value = '';
        idle();
        closeFind();
      });

      var terms = root.querySelectorAll('[data-cf-search-term]');
      for (var t = 0; t < terms.length; t++) {
        terms[t].addEventListener('click', function () {
          input.value = this.getAttribute('data-cf-search-term');
          run();
          input.focus();
        });
      }
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { close(); closeFind(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); closeFind(); }
    });

    var tabs = panel.querySelectorAll('[data-cf-tab]');
    var panes = panel.querySelectorAll('[data-cf-pane]');

    function show(tab) {
      Array.prototype.forEach.call(tabs, function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      Array.prototype.forEach.call(panes, function (p) {
        if (p.getAttribute('data-cf-pane') === tab.getAttribute('data-cf-tab')) p.classList.add('is-on');
        else p.classList.remove('is-on');
      });
    }

    Array.prototype.forEach.call(tabs, function (tab) {
      var key = tab.getAttribute('data-cf-tab');
      var href = TAB_LINKS[key];

      if (href) {
        tab.setAttribute('data-cf-href', href);
        tab.style.cursor = 'pointer';
      }

      tab.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        show(tab);
      });

      tab.addEventListener('focus', function () { show(tab); });

      tab.addEventListener('click', function (e) {
        e.stopPropagation();
        var target = tab.getAttribute('data-cf-href');
        if (!target || tab.getAttribute('aria-selected') !== 'true') {
          e.preventDefault();
          show(tab);
          return;
        }
        e.preventDefault();
        window.location.href = target;
      });
    });

    var cartBtn = root.querySelector('[data-cf-cart]');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        window.setTimeout(function () {
          var dlg = document.querySelector('#cart-drawer');
          var isOpen = dlg && (dlg.open === true || dlg.getAttribute('open') !== null || (dlg.className || '').indexOf('open') !== -1);
          if (!isOpen) window.location.href = '/cart';
        }, 380);
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var el = root.querySelector('[data-cf-count]');
          if (!el) return;
          el.textContent = c.item_count;
          if (c.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('pageshow', refresh);
    window.setInterval(refresh, 2500);
    refresh();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cf-top]');
    for (var i = 0; i < roots.length; i++) start(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();